import { Injectable, EventEmitter } from "@angular/core";
import { TemplateComponent } from "../../template";

@Injectable()
export class LayoutRouterService {
  public active_template: TemplateComponent;

  public onTemplateRegister: EventEmitter<
    TemplateComponent
  > = new EventEmitter();
  public onTemplateUpdate: EventEmitter<TemplateComponent> = new EventEmitter();
  public onTemplateUnregister: EventEmitter<void> = new EventEmitter();

  public registerTemplate(template: TemplateComponent) {
    this.active_template = template;
    this.onTemplateRegister.emit(template);
  }

  public updateTemplate() {
    if (!this.active_template) return;
    this.onTemplateUpdate.emit(this.active_template);
  }

  public unregisterTemplate() {
    this.active_template = null;
    this.onTemplateUnregister.emit();
  }
}
